import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '../typography';
import { Grid, GridJustification, IconButton } from '@material-ui/core';
import ButtonComponent from '../button';
import { ReactComponent as CloseIcon } from '../../../assets/icons/icon-cross-circle.svg';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material';

interface ModalProps {
  label: string;
  children?: React.ReactNode;
  open: boolean;
  onCancelClick?: () => void;
  onClickPublish?: () => void;
  ButtonOutlinePrimary?: string;
  ButtonPrimary?: string;
  alignCenter?: boolean;
  hideCloseIcon?: boolean;
  boxStyle?: SxProps<any>;
}

const style: SxProps<any> = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 550,
  bgcolor: 'background.paper',
  borderRadius: 4,
  boxShadow: '0px 20px 24px -6px rgba(16, 24, 40, 0.08)',
  p: 4,
};

const ModalCustom: React.FC<ModalProps> = ({
  label,
  children,
  open,
  ButtonOutlinePrimary,
  ButtonPrimary,
  onCancelClick,
  onClickPublish,
  alignCenter,
  hideCloseIcon,
  boxStyle,
}) => {
  return (
    <div>
      <Modal open={open} onClose={onCancelClick}>
        <Box sx={{ ...style, ...boxStyle }}>
          <Grid
            container
            justifyContent={alignCenter ? 'center' : 'space-between'}
            alignItems={alignCenter ? 'center' : 'flex-end'}
          >
            <Typography
              style={{ textAlign: alignCenter ? 'center' : 'start' }}
              fontWeight="700"
              color="secondary"
              mb={2}
            >
              {label}
            </Typography>

            {!hideCloseIcon && (
              <IconButton aria-label="close" onClick={onCancelClick}>
                <CloseIcon />
              </IconButton>
            )}
            <Grid item>
              <Typography color="secondary" mb={2}>
                {children}
              </Typography>
            </Grid>
          </Grid>

          <Grid container justifyContent={alignCenter ? 'center' : 'flex-end'}>
            {ButtonOutlinePrimary && (
              <ButtonComponent
                theme="outline-primary"
                mr={2}
                onClick={onCancelClick}
                flex={1}
              >
                {ButtonOutlinePrimary}
              </ButtonComponent>
            )}
            {ButtonPrimary && (
              <ButtonComponent
                theme="primary"
                onClick={onClickPublish}
                flex={1}
              >
                {ButtonPrimary}
              </ButtonComponent>
            )}
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};

export default ModalCustom;
